import React from 'react';
import { Content, ContentCode } from 'models/Content';
import { AppServices } from 'services/AppServices';
import { ContentCodeItem } from 'components/content-code/ContentCodeItem';
import Locale from 'localization/Localization';
import { ContentCodeDetailsView } from 'components/content-code/ContentCodeDetailsView';
import { ModalView } from 'components/common/ModalView';
import { ContentCodeForm } from 'components/content-code/ContentCodeForm';
import { Spinner } from 'components/common/Spinner';
import { Button } from 'react-bootstrap';

interface ContentDetailsViewProps
{
    content: Content;
	onBackClicked: any;
	onEditClicked: any;
}

interface ContentDetailsViewState
{
	contentCodeItems?: ContentCode[];
	selectedContentCode?: ContentCode;
	loadInProgress: boolean;
}

export class ContentDetailsView extends React.Component<ContentDetailsViewProps, ContentDetailsViewState>
{
	constructor(props: ContentDetailsViewProps)
	{
		super(props);

		this.state = {
			contentCodeItems: [],
			selectedContentCode: undefined,
			loadInProgress: true
		};

		this.onOpenContentCodeDetailsView = this.onOpenContentCodeDetailsView.bind(this);
		this.onCloseContentCodeDetailsView = this.onCloseContentCodeDetailsView.bind(this);
		this.getCodes = this.getCodes.bind(this);
	}

	public componentDidMount()
	{
		this.getCodes();
	}

	private async getCodes()
	{
		this.setState({
			contentCodeItems: undefined,
			loadInProgress: true
		});

		AppServices.contentService.getContentCodes(this.props.content.contentId)
			.then((codes: ContentCode[]) =>
			{
				this.setState({
					contentCodeItems: codes,
					loadInProgress: false
				});
			}).catch(reason =>
			{
				console.error(reason);
				this.setState({
					contentCodeItems: undefined,
					loadInProgress: false
				});
			});
	}

	private onOpenContentCodeDetailsView(contentCode: ContentCode)
	{
		console.log("select " + contentCode.contentCode);
		this.setState({
			selectedContentCode: contentCode
		});
	}

	private onCloseContentCodeDetailsView()
	{
		console.log("deselect " + this.state.selectedContentCode);
		this.setState({
			selectedContentCode: undefined
		});

		this.getCodes();
	}

	public render()
	{
		return <React.Fragment>
			{
				this.state.selectedContentCode !== undefined &&
				<ModalView onClose={this.onCloseContentCodeDetailsView} show>
					<ContentCodeDetailsView contentCode={this.state.selectedContentCode} />
				</ModalView>
			}

			<div className='program-content'>
				<Button variant='primary' onClick={() => this.props.onBackClicked()}>{Locale.get('button_back')}</Button>
				<h1>{Locale.get('contentCode_title')}</h1>

				<div className='program-content-container'>

					<div className='program-content-description'>
						<h2>{Locale.get('contentCode_descriptionTitle')}</h2>
						<div>
							<h3>{this.props.content.title}</h3>

							{
								this.props.content.image.isValid() &&
								<img src={this.props.content.image.getUrl()} alt='Content'/>
							}

							<p>{this.props.content.description}</p>
							<Button variant='outline-primary' onClick={this.props.onEditClicked} >
								{Locale.get('contentCode_buttonEdit')}
							</Button>
						</div>
					</div>

					<ContentCodeForm contentId={this.props.content.contentId} onCodeCreated={this.getCodes} />

				</div>

				{this.state.loadInProgress
					? <Spinner />
					: <div className='program-content-codes'>
						<h2 className='text-center'>{Locale.get("contentCode_tableTitle")}</h2>
						<table className='code-table'>
							<colgroup>
								<col span={1} style={{ width: '20%' }} />
								<col span={1} style={{ width: '25%' }} />
								<col span={1} style={{ width: '25%' }} />
								<col span={1} style={{ width: '15%' }} />
								<col span={1} style={{ width: '15%' }} />
							</colgroup>

							<thead>
								<tr>
									<th>{Locale.get("contentCode_columnCode")}</th>
									<th>{Locale.get("contentCode_columnValid")}</th>
									<th>{Locale.get("contentCode_columnBegin")}</th>
									<th>{Locale.get("contentCode_columnActivations")}</th>
									<th>{Locale.get("contentCode_columnStatus")}</th>
								</tr>
							</thead>
							<tbody>
								{
									this.state.contentCodeItems === undefined &&
									<tr>
										<td colSpan={6}>{Locale.get("contentCode_tableLoadError")}</td>
									</tr>
								}
								{
									this.state.contentCodeItems !== undefined &&
									this.state.contentCodeItems.length === 0 &&
									<tr>
										<td colSpan={6}>{Locale.get("contentCode_tableEmpty")}</td>
									</tr>
								}
								{
									this.state.contentCodeItems !== undefined &&
									this.state.contentCodeItems.length > 0 &&
									this.state.contentCodeItems.map((item, i) =>
										<ContentCodeItem code={item} key={item.contentId + '_' + i} onClick={this.onOpenContentCodeDetailsView} />)
								}
							</tbody>
						</table>
					</div>
				}
			</div>
		</React.Fragment>;
	}
}